
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1wp4s_1f4zl_5",
  "file-input": "awsui_file-input_1wp4s_1f4zl_9",
  "file-input-button": "awsui_file-input-button_1wp4s_1f4zl_24",
  "force-focus-outline-icon": "awsui_force-focus-outline-icon_1wp4s_1f4zl_24",
  "force-focus-outline-button": "awsui_force-focus-outline-button_1wp4s_1f4zl_45"
};
  